export const products = [
  {
    id: 1,
    title: "Навушники",
    price: 1200,
    category: "tech"
  },
  {
    id: 2,
    title: "Футболка",
    price: 700,
    category: "clothes"
  },
  {
    id: 3,
    title: "Смарт-годинник",
    price: 2500,
    category: "tech"
  }
]